import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { Messages } from 'src/app/constants/messages';
import { Utilities } from 'src/app/constants/utilities';
import { ServicecallService } from 'src/app/services/servicecall.service';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';

@Component({
  selector: 'app-tenant-alertrule-modal',
  templateUrl: './tenant-alertrule-modal.component.html',
  styleUrls: ['./tenant-alertrule-modal.component.css']
})
export class TenantAlertruleModalComponent implements OnInit, OnDestroy {

  alertListForTenant: any = [];
  alertSeveritydd: any = [];
  alertActionsdd: any = [];
  alertCategorydd: any = [];
  alertCategoryNaturedd: any = [];
  uom: any = [];
  scope: any = [];
  classType: any = [];
  zoneRiskTypeList: any = [];
  booleanArray: any = ['true', 'false'];
  alertRuleForm: any;
  formSubmitted: boolean = false;
  errorMessage: any = null;
  bindSelectedAlertRuleData: any;

  private _alertIdList: any = [];
  private _attribute: any = ["alertSeverity", "alertAction", "alertCategory", "categoryNature", "unitOfMeasurement", "typ", "zoneRiskType", "classType"]
  private _dropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'name',
    itemsShowLimit: 3,
    allowSearchFilter: true,
  };
  private _afterClosedSubscription: Subscription;
  private _alertIdListSubscription: Subscription;
  private _insertAlertRuleSubscription: Subscription;

  
  @Input() alertRuleData: any; //Edit
  @Input() alertRuleEdit: any; //Edit true
  @Input() alertRuleView: any //View true

  constructor(
    private _activeModal: NgbActiveModal,
    private _fb: FormBuilder,
    private _service: ServicecallService,
    private _dialog: MatDialog
  ) {
    this._buildForm()
  }

  ngOnInit(): void {
    this._configurationInfo()
  }
  ngOnDestroy(): void {
    this._afterClosedSubscription?.unsubscribe();
    this._alertIdListSubscription?.unsubscribe();  
    this._insertAlertRuleSubscription?.unsubscribe();  
  }
  closeModal() {
    if (this.alertRuleForm.dirty) {
      let dialogRef = this._dialog.open(AlertDialogComponent, {
        data: { msg: Messages.UNSAVED_CHANGES, type: null },
        disableClose: true
      });
      this._afterClosedSubscription = dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this._activeModal.close();
        }
      });
    }
    else {
      this._activeModal.close();
    }
  }
  onSubmit() {
    if (this.alertRuleForm.invalid) {
      return;
    }
    this._insertAlertRule()


  }
  onSelectEvent(item: any) {

    let data: any = this.alertListForTenant.find((x: any) => x.alertId === Number(item['value']))
    this._patchValue(data)

  }
  get formValues() {
    return this.alertRuleForm.controls;
  }
  private _buildForm() {
    this.alertRuleForm = this._fb.group({
      alertId: ['', [Validators.required]],
      alertDesc: ['', [Validators.required]],
      class: [''],
      type: [''],
      alertSeverity: [''],
      action: [''],
      alertCategory: [''],
      categoryNature: [''],
      excludedZoneRiskTypes: [''],
      sms: [''],
      email: [''],
      c2d: [''],
      webNotification: [''],
      pushNotification: [''],
      autoClose: [''],
      mtype: ['', [Validators.required]],
      message: ['', [Validators.required]],
      triggerDelay: ['', [Validators.required]],
      duplicateDuration: ['', [Validators.required]],
      delayAlertDuration: ['', [Validators.required]],
      uom: [''],
      active: ['', [Validators.required]]



    });

  }
  private _configurationInfo() {
    // this._service.configurationsInfo(this._attribute).subscribe((res: any) => {
    //   if (res['status']) {
    //     let data: any = res['response']
    //     data.forEach((element: any) => {
    //       if (element['attribute'] === "alertSeverity") {
    //         element['values']['alertSeverity'].sort((a: any, b: any) => a.index - b.index);
    //         element['values']['alertSeverity'].forEach((element2: any) => {
    //           this.alertSeveritydd.push(element2['name'])
    //         });

    //       }

    //       if (element['attribute'] === "alertAction") {
    //         element['values']['alertAction'].sort((a: any, b: any) => a.index - b.index);
    //         element['values']['alertAction'].forEach((element2: any) => {
    //           this.alertActionsdd.push(element2['name'])
    //         });
    //       }
    //       if (element['attribute'] === "alertCategory") {
    //         element['values']['alertCategory'].sort((a: any, b: any) => a.index - b.index);
    //         element['values']['alertCategory'].forEach((element2: any) => {
    //           this.alertCategorydd.push(element2['name'])

    //         });
    //       }
    //       if (element['attribute'] === "categoryNature") {
    //         element['values']['categoryNature'].sort((a: any, b: any) => a.index - b.index);
    //         element['values']['categoryNature'].forEach((element2: any) => {
    //           this.alertCategoryNaturedd.push(element2['name'])
    //         });
    //       }
    //       if (element['attribute'] === "unitOfMeasurement") {
    //         element['values']['measurement'].sort((a: any, b: any) => a.index - b.index);
    //         element['values']['measurement'].forEach((element2: any) => {
    //           this.uom.push(element2['name'])
    //         });
    //       }

    //       if (element['attribute'] === "typ") {
    //         element['values']['scope'].sort((a: any, b: any) => a.index - b.index);
    //         element['values']['scope'].forEach((element2: any) => {
    //           this.scope.push(element2['name'])
    //         });
    //       }
    //       if (element['attribute'] === "classType") {
    //         element['values']['classType'].sort((a: any, b: any) => a.index - b.index);
    //         element['values']['classType'].forEach((element2: any) => {
    //           this.classType.push(element2['name'])
    //         });


    //       }
    //       //NS112
    //       if (element['attribute'] === "zoneRiskType") {
    //         let data = element['values']['zoneRiskType'];
    //         let d1: any = []
    //         data.forEach((elements: any) => {
    //           d1.push(elements['name'])
    //         });
    //         this.zoneRiskTypeList = d1;
    //       }
    //       //NS112
    //     });
    //     this.loadTenant();
    //   }
    // });
    this.uom = (this._service.getConfiguration('unitOfMeasurement')) ? this._service.getConfiguration('unitOfMeasurement')['measurement'].sort((a: any, b: any) => a.index - b.index)?.map(({ name }) => name) : [];
    this.scope = (this._service.getConfiguration('typ')) ? this._service.getConfiguration('typ')['scope'].sort((a: any, b: any) => a.index - b.index)?.map(({ name }) => name) : [];
    this.alertSeveritydd = (this._service.getConfiguration('alertSeverity')) ? this._service.getConfiguration('alertSeverity')['alertSeverity'].sort((a: any, b: any) => a.index - b.index)?.map(({ name }) => name) : [];
    this.alertActionsdd = (this._service.getConfiguration('alertAction')) ? this._service.getConfiguration('alertAction')['alertAction'].sort((a: any, b: any) => a.index - b.index)?.map(({ name }) => name) : [];
    this.alertCategorydd = (this._service.getConfiguration('alertCategory')) ? this._service.getConfiguration('alertCategory')['alertCategory'].sort((a: any, b: any) => a.index - b.index)?.map(({ name }) => name) : [];
    this.alertCategoryNaturedd = (this._service.getConfiguration('categoryNature')) ? this._service.getConfiguration('categoryNature')['categoryNature'].sort((a: any, b: any) => a.index - b.index)?.map(({ name }) => name) : [];
    this.classType = (this._service.getConfiguration('classType')) ? this._service.getConfiguration('classType')['classType'].sort((a: any, b: any) => a.index - b.index)?.map(({ name }) => name) : [];
    this.zoneRiskTypeList = (this._service.getConfiguration('zoneRiskType')) ? this._service.getConfiguration('zoneRiskType')['zoneRiskType']?.map(({ name }) => name) : [];
    this._loadTenant();
  }
  private _loadTenant() {
    this._alertIdList.length = 0;
    this.alertListForTenant.length = 0;
    let _postData: any = {
      siteId: null,
      tab: 'tenant'
    }
    this._alertIdListSubscription = this._service.alertIdList(_postData).subscribe((res: any) => {
      if (res['status']) {
        let data: any = res['response']['data']
        if (data.length > 0) {
          this.alertListForTenant = data;
          data.forEach((element: any, index: number) => {
            let d: any = { id: index, name: element['alertId'] + "-" + element['alertDesc'] }
            this._alertIdList = this._alertIdList.concat(d)
          });
        }


      }
      else {
        this.errorMessage = res['response']['message']
      }

    })
  }
  
  private _patchValue(data: any) {

    if (data) {
      this.bindSelectedAlertRuleData = true;
      this.alertRuleForm.patchValue({ alertId: data['alertId'] });
      this.alertRuleForm.patchValue({ alertDesc: data['alertDesc'] });
      this.alertRuleForm.patchValue({ sms: data['sms'].toString() });
      this.alertRuleForm.patchValue({ email: data['email'].toString() });
      this.alertRuleForm.patchValue({ c2d: data['c2d'].toString() });
      this.alertRuleForm.patchValue({ webNotification: data['webNotification'].toString() });
      this.alertRuleForm.patchValue({ pushNotification: data['pushNotification'].toString() });
      this.alertRuleForm.patchValue({ autoClose: data['autoClose'].toString() });
      this.alertRuleForm.patchValue({ mtype: data['mtype'] });
      this.alertRuleForm.patchValue({ message: data['message'] });
      this.alertRuleForm.patchValue({ type: data['type'] });
      this.alertRuleForm.patchValue({ triggerDelay: data['triggerDelay'] });
      this.alertRuleForm.patchValue({ duplicateDuration: data['duplicateDuration'] });
      this.alertRuleForm.patchValue({ delayAlertDuration: data['delayAlertDuration'] });
      this.alertRuleForm.patchValue({ active: data['active'].toString() });
      this.alertRuleForm.patchValue({ alertSeverity: data['alertSeverity'] });
      this.alertRuleForm.patchValue({ action: data['action'] });
      this.alertRuleForm.patchValue({ alertCategory: data['alertCategory'] });
      this.alertRuleForm.patchValue({ class: data['class'] });
      this.alertRuleForm.patchValue({ categoryNature: data['categoryNature'] });
      this.alertRuleForm.patchValue({ excludedZoneRiskTypes: data['excludedZoneRiskTypes'][0] });
      this.alertRuleForm.patchValue({ uom: data['uom'] });
    }


  }

  private _insertAlertRule() {
    let setArray: any = [];
    setArray.push({
      alertId: Number(this.alertRuleForm.value['alertId']),
      alertCategory: this.alertRuleForm.value['alertCategory'],
      alertDesc: this.alertRuleForm.value['alertDesc'],
      alertSeverity: this.alertRuleForm.value['alertSeverity'],
      action: this.alertRuleForm.value['action'],
      categoryNature: this.alertRuleForm.value['categoryNature'],
      sms: this.alertRuleForm.value['sms'],
      email: Boolean(this.alertRuleForm.value['email']),
      c2d: Boolean(this.alertRuleForm.value['c2d']),
      webNotification: Boolean(this.alertRuleForm.value['webNotification']),
      pushNotification: Boolean(this.alertRuleForm.value['pushNotification']),
      excludedZoneRiskTypes: this.alertRuleForm.value['excludedZoneRiskTypes'],
      autoClose: Boolean(this.alertRuleForm.value['autoClose']),
      mtype: Number(this.alertRuleForm.value['mtype']),
      message: this.alertRuleForm.value['message'],
      triggerDelay: Number(this.alertRuleForm.value['triggerDelay']),
      duplicateDuration: Number(this.alertRuleForm.value['duplicateDuration']),
      delayAlertDuration: Number(this.alertRuleForm.value['delayAlertDuration']),
      uom: this.alertRuleForm.value['uom'],
      active: Boolean(this.alertRuleForm.value['active']),
      type: 'tenant',
      group: 'userdefined',
      class: this.alertRuleForm.value['class'],
      metadata: {
        "createdBy": localStorage.getItem("userId")
      }
    })
    this._insertAlertRuleSubscription = this._service.insertAlertRule(setArray, 'tenant').subscribe((res: any) => {
      if (res['status']) {
        if (res['response']['inserted'] === true) {
          this._service.toasterService({ type: 'success', msg: res['response']['message'] });
          this._activeModal.close();

        }
        else {
          this._service.toasterService({ type: 'error', msg: res['response']['message'] });
        }
      }
      else {
        this._service.toasterService({ type: 'error', msg: res['response']['message'] });
      }

    })
  }

  private _updateAlertRule() {
    let changedValues = Utilities.getDirtyValues(this.alertRuleForm)
  }

}
